
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const mountedRelationalDatabaseDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.mountedRelationalDatabase.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.mountedRelationalDatabase.linkedServiceType],
    displayName: stringResources.MountedRelationalDatabase_DisplayText,
    datasetKind: 'table',
    isSource: false,
    isSink: true,
    icon: {
        className: 'svg-i_mirroredDatabase'
    },
    isFirstClass: true,
    category: ['Database'],
    copySourceControls: [],
    copySinkControls: []
};
